import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  coveoResults: {},
  distance: 50,
  maxDistance: 0,
  showAnyLocation: false,
  isVirtual: false,
  zipCode: '',
  dayOfBirth: null,
  selectedSiteId: '',
  selectedSiteName: '',
};

const coveoResult = createSlice({
  name: 'coveo-result',
  initialState,
  reducers: {
    setCoveoResult: (state = initialState.coveoResults, action: PayloadAction<any>) => {
      return {
        ...state,
        coveoResults: action.payload,
      };
    },
    setDistance: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        distance: action.payload,
      };
    },
    setMaxDistance: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        maxDistance: action.payload,
      };
    },
    setShowAnyLocation: (state) => {
      return {
        ...state,
        showAnyLocation: !state.showAnyLocation,
      };
    },
    setIsVirtual: (state) => {
      return {
        ...state,
        isVirtual: !state.isVirtual,
      };
    },
    setZipCode: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        zipCode: action.payload,
      };
    },
    setDayOfBirth: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        dayOfBirth: action.payload,
      };
    },
    setConditionFilterValue: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        conditionFilterValue: action.payload,
      };
    },
    setChangedFilterValue: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        changedFilterValue: action.payload,
      };
    },
    setSelectedSite: (state, action: PayloadAction<{ siteId: string; siteName: string }>) => {
      return {
        ...state,
        selectedSiteId: action.payload.siteId,
        selectedSiteName: action.payload.siteName,
      };
    },
    clearSelectedSite: (state) => {
      return {
        ...state,
        selectedSiteId: '',
        selectedSiteName: '',
      };
    },
  },
});

export const {
  setCoveoResult,
  setDistance,
  setMaxDistance,
  setShowAnyLocation,
  setZipCode,
  setIsVirtual,
  setDayOfBirth,
  setConditionFilterValue,
  setChangedFilterValue,
  setSelectedSite,
  clearSelectedSite,
} = coveoResult.actions;
export default coveoResult.reducer;
